import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import { Vuelidate } from 'vuelidate/src';
import { sync } from 'vuex-router-sync';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueABTasty from 'vue-abtasty';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faFacebookMessenger,
    faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { faSms, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
import App from '@/App.vue';
import { addHreflang } from '@/helpers/HreflangHelpers';

library.add(
    faExchangeAlt,
    faFacebookMessenger,
    faSms,
    faWhatsapp,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

sync(store, router);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);

if (process.env.VUE_APP_MODE !== 'canvasser') {
    Vue.use(VueABTasty, {
        identifier: process.env.VUE_APP_AB_TASTY_KEY,
        async: true,
    });
}

Vue.config.productionTip = false;

if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_ENV,
        debug: process.env.VUE_APP_DEBUG,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
                logErrors: true,
            }),
        ],
    });
}

let savedQueryParams = JSON.parse(localStorage.getItem('query-params'));
delete savedQueryParams?.cms;
let globalQueryParams = { ...savedQueryParams };

let queryString = document.URL.split('?')[1];

let searchParams = new URLSearchParams(queryString);
searchParams.forEach((value, key) => {
    globalQueryParams[key] = value;
});
localStorage.setItem('query-params', JSON.stringify(globalQueryParams));

if (queryString) {
    localStorage.setItem('query-string', queryString);
}
globalQueryParams.queryString = localStorage.getItem('query-string');

Vue.prototype.$globalQueryParams = globalQueryParams;

addHreflang();

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
